<template>
  <div class="container-fluid">
    <transaction-form
      :loading="loading"
      :transactionData="transaction"
      :formErrors="formErrors"
      @transactionSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultTransaction from "../defaultTransaction";
import TransactionForm from "../partials/TransactionForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    TransactionForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      transaction: cloneDeep(defaultTransaction),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(transaction) {
      this.loading = true;

      const transactionData = cloneDeep(transaction);
      delete transactionData.id;

      try {
        await this.$store.dispatch(
          "elixiopayTransactions/add",
          transactionData
        );
        this.$notify({
          type: "success",
          message: this.$t("NUVEI_CARDS.NUVEI_CARD_ADDED"),
        });
        const transaction = await this.$store.getters[
          "elixiopayTransactions/elixiopayTransaction"
        ];
        this.$emit("onViewTransaction", transaction, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
